import React, { useEffect, useState } from "react";
import Classes from "./styles/style.module.css";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import { useParams } from "react-router";
import MatchMenu from "./MatchMenu";
import RulesPopUp from "./TutorialDialog";
import Rules from "./Rules";
import Awards from "./Awards";
import StartMatchModal from "./StartMatchModal";
import useMathcActions from "../../assets/Hooks/Match";
import {
  setAllQuestions,
  setAnsweredQuestoinsCount,
  setMaxAnswer,
  setQuiz,
  setQuizDuration,
  setfinalizeQuiz,
  setfinalizeReport,
} from "../../assets/redux/actions/Quiz";
import { useDispatch } from "react-redux";

const MiniMatch = () => {
  const [showRules, setshowRules] = useState(false);
  const [showhint, setShowhint] = useState(false);
  const [showAwards, setShowAwards] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { getQuizData, matchTitle, matchDsc, matchLogo, start } =
    useMathcActions();
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setfinalizeQuiz(false));
    dispatch(setAnsweredQuestoinsCount(0));
    dispatch(setQuiz(null));
    dispatch(setQuizDuration(0));
    dispatch(setMaxAnswer(0));
    dispatch(setfinalizeReport(null));
    dispatch(setAllQuestions(null));
    if (id) {
      getQuizData(id);
    }
  }, [id]);

  const takeQuiz = () => setShowModal(true);
  const handleHideRules = () => setshowRules(false);
  const handleHideHint = () => setShowhint(false);
  const handleHideAwards = () => setShowAwards(false);

  return (
    <>
      <AnimatedPageContainer>
        <div className={Classes.matchePageContainer}>
          {matchLogo ? (
            <img
              src={matchLogo}
              alt="joftPoockLogo"
              className={Classes.matchLogo}
            />
          ) : null}
          <div className="w-100 text-center ">
            <h4 className="my-5">{matchTitle}</h4>
            <p>{matchDsc}</p>
          </div>
          <MatchMenu
            matchDescription={matchDsc}
            takeQuiz={takeQuiz}
            showRules={() => setshowRules(true)}
            showHint={() => setShowhint(true)}
            showAwards={() => setShowAwards(true)}
            quizId={id}
            isMini={true}
          />
          <RulesPopUp show={showRules} handleClose={handleHideRules} />
          <Rules show={showhint} handleClose={handleHideHint} />
          <Awards show={showAwards} handleClose={handleHideAwards} />
        </div>
      </AnimatedPageContainer>
      <StartMatchModal
        handleClose={() => setShowModal(false)}
        showModal={showModal}
        start={() => start(id)}
      />
    </>
  );
};

export default MiniMatch;
